{
    "status": 200,
    "success": true,
    "data": {
        "user": {
            "id": "9db18147-344c-4b3a-9902-02f806f5aa62",
            "name": "John Wick",
            "avatar": {
                "name": "e99f2c26-41f5-40ad-8e86-8d84849aee25.png",
                "collection_name": "avatar",
                "url": "https:\/\/dev-platform.valesaudesempre.com.br\/media\/avatar\/e99f2c26-41f5-40ad-8e86-8d84849aee25.png?template=medium"
            }
        },
        "merchant": {
            "id": "c71d908b-00a7-4daa-94d4-8e14edadc036",
            "document_number": "12.345.678\/0001-90",
            "company_name": "Company Name",
            "trading_name": "Company Name"
        },
        "units": [
            {
                "id": "a1734fe3-d954-40c7-b26b-774a66aeec6f",
                "document_number": "12.345.678\/0001-90",
                "company_name": "Company Name",
                "trading_name": "Company Name"
            }
        ],
        "settings": {
            "sale": {
                "direct": true,
                "item": true
            },
            "taxes": {
                "mdr": 5
            }
        },
        "token": "123token",
        "expires_in": 3600
    }
}